import React from 'react';
import moment from 'moment';
import { TransfersLoading } from '../Transfers.loading';
import { TransfersEmpty } from '../Transfers.empty';
import { TransfersError } from '../Transfers.error';
import { useTransfersQuery, TransferDTO } from '../../../../../../../../../api/useTransfersQuery';
import { IconButton } from '../../../../../../../../../../CommonComponents/OPL/IconButton/IconButton';
import {
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from '../../../../../../../../../../CommonComponents/OPL/Table/Table';
import { Text } from '../../../../../../../../../../CommonComponents/OPL/Text/Text';

// TODO: Update after backend changes API response with OPL migration: https://dev.azure.com/orionadvisor/Orion%20Agile/_workitems/edit/127739

interface RejectedTransfersProps {
  managedAccountId: string;
  setSelectedTransfer(transfer: TransferDTO): void;
  setIsConfirmationModalOpen(isOpen: boolean): void;
}

export const RejectedTransfers: React.FC<RejectedTransfersProps> = ({
  managedAccountId,
  setSelectedTransfer,
  setIsConfirmationModalOpen,
}) => {
  const { data, isError, isFetching, refetch } = useTransfersQuery(managedAccountId);

  if (isFetching) {
    return <TransfersLoading />;
  }

  if (isError) {
    return <TransfersError onRetry={refetch} />;
  }

  if (!data) {
    return null;
  }

  const { rejected } = data;

  if (rejected.length === 0) {
    return <TransfersEmpty />;
  }

  return (
    <>
      <TableHeader>
        <TableRow>
          <TableCell width="11%">
            <Text>Date</Text>
          </TableCell>
          <TableCell width="82%" justifyContent="start">
            <Text>Name</Text>
          </TableCell>
          <TableCell width="7%" justifyContent="center">
            &nbsp;
          </TableCell>
        </TableRow>
      </TableHeader>

      <TableBody maxHeight="264px">
        {rejected.map(transfer => (
          <TableRow key={transfer.transferId} height={36}>
            <TableCell width="11%">
              <Text>{moment(transfer.transferDate).format('MM/DD/YYYY')}</Text>
            </TableCell>
            <TableCell width="82%">
              <Text>{transfer.description}</Text>
            </TableCell>
            <TableCell width="7%" justifyContent="center">
              <IconButton
                variant="subtleInactive"
                icon="fal fa-times"
                onClick={() => {
                  setSelectedTransfer(transfer);
                  setIsConfirmationModalOpen(true);
                }}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};
